import React from "react";
import { createPortal } from "react-dom";

const PortalContainer = ({
  container,
  component,
  props,
  fadeIn,
  fadeContent,
}) => {
  if (!component && !fadeIn) return null;

  let elementToRender = component ? React.cloneElement(component, props) : null;

  if (fadeIn) {
    elementToRender = <div>{fadeContent}</div>;
  }

  return createPortal(elementToRender, container);
};

export default PortalContainer;
